"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var Toggle =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Toggle, _PureComponent);

  function Toggle() {
    (0, _classCallCheck2["default"])(this, Toggle);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Toggle).apply(this, arguments));
  }

  (0, _createClass2["default"])(Toggle, [{
    key: "render",
    value: function render() {
      var _cx;

      var _this$props = this.props,
          on = _this$props.on,
          onClick = _this$props.onClick,
          onText = _this$props.onText,
          offText = _this$props.offText,
          size = _this$props.size,
          disabled = _this$props.disabled;
      return _react["default"].createElement("div", {
        className: (0, _emotion.cx)('toggle', (_cx = {}, (0, _defineProperty2["default"])(_cx, "toggle-".concat(size), size), (0, _defineProperty2["default"])(_cx, 'toggle-on', on), (0, _defineProperty2["default"])(_cx, 'toggle-off', !on), (0, _defineProperty2["default"])(_cx, "disabled", disabled), (0, _defineProperty2["default"])(_cx, "clickable", !disabled), _cx)),
        onClick: disabled ? null : onClick
      }, _react["default"].createElement("div", {
        className: "toggle-label"
      }, on ? onText : offText), _react["default"].createElement("div", {
        className: "toggle-switch"
      }));
    }
  }]);
  return Toggle;
}(_react.PureComponent);

exports["default"] = Toggle;
Toggle.propTypes = {
  on: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  onText: _propTypes["default"].string,
  offText: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['sm']),
  disabled: _propTypes["default"].bool
};
Toggle.defaultProps = {
  onText: 'On',
  offText: 'Off',
  disabled: false
};